import React, { useEffect, useState } from "react";
import HeaderSection from "./HeaderSection";
import Pagination from "../reusable_components/Pagination";
import { findInventory } from "../api/partstechApi.js";
import { toast } from "react-toastify";
import Table from "../reusable_components/Table.jsx";

const PartstechInventory = () => {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    // const [selectedRows, setSelectedRows] = useState([]);

    // const handleRowSelect = (rowIndex) => {
    //     const updatedFiles = [...files];
    //     const rowId = updatedFiles[rowIndex].id;

    //     updatedFiles[rowIndex].selected = !updatedFiles[rowIndex].selected;

    //     setSelectedRows((prevSelectedRows) => {
    //         if (updatedFiles[rowIndex].selected) {
    //             return [...prevSelectedRows, rowId];
    //         } else {
    //             return prevSelectedRows.filter((id) => id !== rowId);
    //         }
    //     });

    //     setFiles(updatedFiles);
    // };

    const fetchFiles = async (page = 1) => {
        setLoading(true);
        setError(null);

        try {
            const response = await findInventory(page);
            setFiles(response.data?.data || []);
            setTotalPages(response.data?.pagination?.totalPages || 1);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { header: "Image", key: "imageUrl", width: "10%", type: "img" },
        { header: "Name", key: "partName", width: "20%" },
        { header: "Part Id", key: "partId", width: "20%" },
        { header: "Category", key: "partCategory", width: "10%" },
        { header: "Quantity", key: "quantity", width: "10%" },
        { header: "Price", key: "pricePrice", width: "10%", render: (value) => value ? `$${value.toFixed(2)}` : "$0" }, // price including core and discount
        // { header: "Retail Price", key: "priceRetail", width: "10%", render: (value) => value ? `$${value.toFixed(2)}` : "$0" },  // price+markup 
        { header: "Cost", key: "priceCost", width: "10%", render: (value) => `$${value.toFixed(2)}` }, // price with discount ,Excludes any core charges.
        { header: "List Price", key: "priceList", width: "10%", render: (value) => value ? `$${value.toFixed(2)}` : "$0" }, //list price from partstech
    ];

    useEffect(() => {
        fetchFiles(currentPage);
        setFiles((prevFiles) =>
            prevFiles.map((file) => ({ ...file, selected: false }))
        );
    }, [currentPage]);

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    if (loading) return <div>Loading data...</div>;
    if (error) return toast.error("Could not get inventory", { autoClose: 3000 });

    return (
        <div>
            <div className="flex justify-between items-center mb-3 text-center">
                <HeaderSection title={"Inventory"} />
            </div>
            <Table data={files} columns={columns}
            // onRowSelect={handleRowSelect}
            />
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </div>
    );
};

export default PartstechInventory;
